import React from 'react';
import PropTypes from 'prop-types';
import { useRecoilValue } from 'recoil';
import DiamondBalanceAtom from '../../../recoil/cashout/DiamondBalanceAtom';
import ItemConvertThumbnail from './ItemConvertThumbnail';
import Diamond from '../../icons/Diamond';
import { getProductFormattedNumber } from '../../helpers/CurrencyUtils';
import { getProductAwardAmount, getProductDisplayName } from '../../helpers/ProductUtils';

export default function ItemConvertCatalogPackages({ packages, onClick }) {
  const diamondBalance = useRecoilValue(DiamondBalanceAtom);

  const isPurchasable = (p) => p && p.purchase && (diamondBalance >= p.purchase.price);

  return (
    <ul className="member-diamonds-to-item-convert">
      {packages.map((pack) => {
        const amount = getProductAwardAmount(pack);

        return (
          <li key={pack.productId}>
            <div className="to-item-convert-name-container">
              <div className="to-item-convert-icon">
                <ItemConvertThumbnail product={pack} />
              </div>

              <span>
                {amount > 1 && (
                  <>
                    <span className="to-item-convert-amount">
                      {getProductFormattedNumber(amount)}
                      {' x'}
                    </span>
                    {' '}
                  </>
                )}
                {getProductDisplayName(pack)}
              </span>
            </div>
            <div>
              <button
                className="btn btn-success btn-convert"
                type="button"
                onClick={() => { onClick(pack); }}
                disabled={!isPurchasable(pack)}
              >
                <div className="to-item-convert-diamond-wrapper">
                  <div className="to-item-convert-diamond">
                    <Diamond />
                  </div>
                  <span>{getProductFormattedNumber(pack.purchase.price)}</span>
                </div>
              </button>
            </div>
          </li>
        );
      })}
    </ul>
  );
}
ItemConvertCatalogPackages.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  packages: PropTypes.arrayOf(PropTypes.object).isRequired,
  onClick: PropTypes.func.isRequired,
};
